// Choices offered when reporting a danger. Firestore stores the value; firestore.rules accepts only these values.

export const dangerTypes = [
  { value: "arbre", text: "Arbre dans la rivière" },
  { value: "eboulis", text: "Nouvel éboulis de roches" },
  { value: "rapide_modifie", text: "Le rapide a changé" },
  { value: "autre", text: "Autre" },
];

export const dangerImpacts = [
  { value: "gauche", text: "Bloque la ligne de gauche" },
  { value: "centre", text: "Bloque la ligne du centre" },
  { value: "droite", text: "Bloque la ligne de droite" },
  { value: "complet", text: "Bloque entièrement le rapide" },
  { value: "portage", text: "Portage du rapide recommandé" },
];

export const dangerCanStop = [
  { value: "oui", text: "Oui" },
  { value: "non", text: "Non" },
  { value: "autre", text: "Autre" },
];
